<template>
  <transition name="toast">
    <div class="toast-wrapper" :class="position" v-show="show">
      <div class="toast-tip" :class="{'with-image': imgTypes.indexOf(imgType) !== -1}">
        <div class="toast-img" v-if="imgTypes.indexOf(imgType) !== -1">
          <i class="iconfont" :class="[{'icon-gouxuan1': imgType === 'success'}, {'icon-error': imgType === 'error'}]"></i>
        </div>
        <div v-html="message">
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      imgTypes: ['success', 'error']
    };
  },
  props: {
    message: String,
    position: {
      type: String,
      default: 'center'
    },
    imgType: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.toast-wrapper {
  position: fixed;
  max-width: 90%;
  height: 30px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 14px;

  &.center {
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  &.top {
    top: 10%;
  }

  &.bottom {
    bottom: 10%;
  }

  .toast-tip {
    padding: 8px;
    color: #ffffff;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.7);

    &.with-image {
      padding: 10px 15px 15px 15px;
    }

    .toast-img {
      text-align: center;
      padding: 10px;

      .iconfont {
        font-size: 30px;
      }
    }

    p {
      margin-top: 3px;
    }
  }
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.3s linear;
}
</style>
